"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _recompose = require("recompose");

var _Anatomogram = _interopRequireDefault(require("./Anatomogram"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var arrayDifference = function arrayDifference(arr1, arr2) {
  return Array.isArray(arr1) && Array.isArray(arr2) ? arr1.filter(function (e) {
    return !arr2.includes(e);
  }) : arr1;
};

var elementMarkup = function elementMarkup(colour, opacity) {
  return {
    fill: colour,
    opacity: opacity
  };
};

var idsWithMarkupAccordingToCurrentColoringScheme = function idsWithMarkupAccordingToCurrentColoringScheme(_ref) {
  var showIds = _ref.showIds,
      showColour = _ref.showColour,
      showOpacity = _ref.showOpacity,
      highlightIds = _ref.highlightIds,
      highlightColour = _ref.highlightColour,
      highlightOpacity = _ref.highlightOpacity,
      selectIds = _ref.selectIds,
      selectColour = _ref.selectColour,
      selectOpacity = _ref.selectOpacity;
  var uniqueShowIds = arrayDifference(showIds, [].concat(_toConsumableArray(highlightIds), _toConsumableArray(selectIds)));
  var uniqueHighlightIds = arrayDifference(highlightIds, selectIds); //Given an element and its ids, we take the first element of this array having one of the ids

  return [].concat(selectIds.map(function (id) {
    return {
      id: id,
      markupNormal: elementMarkup(selectColour, selectOpacity),
      markupUnderFocus: elementMarkup(selectColour, selectOpacity + 0.2)
    };
  }), uniqueHighlightIds.map(function (id) {
    return {
      id: id,
      markupNormal: elementMarkup(highlightColour, highlightOpacity),
      markupUnderFocus: elementMarkup(highlightColour, highlightOpacity + 0.2)
    };
  }), uniqueShowIds.map(function (id) {
    return {
      id: id,
      markupNormal: elementMarkup(showColour, showOpacity),
      markupUnderFocus: elementMarkup(highlightColour, highlightOpacity + 0.2)
    };
  }));
};

var addColoringScheme = (0, _recompose.compose)((0, _recompose.defaultProps)({
  showIds: [],
  highlightIds: [],
  selectIds: [],
  showColour: "grey",
  highlightColour: "red",
  selectColour: "purple",
  showOpacity: 0.4,
  highlightOpacity: 0.4,
  selectOpacity: 0.4
}), (0, _recompose.withPropsOnChange)((0, _lodash.negate)(_lodash.isEqual), function (props) {
  return {
    idsWithMarkup: idsWithMarkupAccordingToCurrentColoringScheme(props)
  };
}));
var normaliseSpecies = (0, _recompose.mapProps)(function (props) {
  return Object.assign({}, props, {
    species: props.species.toLowerCase().replace(/ +/, "_")
  });
});
var addDefaultCallbacks = (0, _recompose.defaultProps)({
  onMouseOver: function onMouseOver() {},
  onMouseOut: function onMouseOut() {},
  onClick: function onClick() {}
});
var definePropTypes = (0, _recompose.setPropTypes)({
  atlasUrl: _propTypes["default"].string.isRequired,
  species: _propTypes["default"].string.isRequired,
  idsWithMarkup: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    markupNormal: _propTypes["default"].object.isRequired,
    markupUnderFocus: _propTypes["default"].object.isRequired
  })).isRequired,
  onMouseOver: _propTypes["default"].func.isRequired,
  onMouseOut: _propTypes["default"].func.isRequired,
  onClick: _propTypes["default"].func.isRequired
});
var defineDefaultProps = (0, _recompose.defaultProps)({
  atlasUrl: "https://www.ebi.ac.uk/gxa/"
});

var _default = (0, _recompose.compose)(addColoringScheme, _recompose.onlyUpdateForPropTypes, definePropTypes, defineDefaultProps, addDefaultCallbacks, normaliseSpecies)(_Anatomogram["default"]);

exports["default"] = _default;